import styled from 'styled-components'

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: 40px 46px;
  max-width: 520px;
`

export const TituloPrincipal = styled.h2`
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 35px;
  margin-bottom: 24px;
`

export const ContainerDoConteudo = styled.div`
  display: flex;
  flex-direction: column;

  & > p {
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }

  strong {
    font-weight: 600;
  }
`

export const ListaAvisos = styled.ul`
  margin: 0 0 8px 18px;
  padding: 0;

  li {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 10px;
    list-style: disc;
  }
`

export const ContainerDosBotoes = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  & > button:nth-of-type(1) {
    margin-right: 16px;
  }
`
